import App from './ui/App.svelte';

// render UI
const app = new App({
  target: document.body
});

export default app;